<template>
  <div class="mobile-Us">
    <aside class="mobile-Us-header" style="background-image: url(/static/img/home_bg.7384284.png)">
      <div class="mobile-Us-tit">
        <div class="mobile-Us-tit-intro">
          <h2 style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
            专注于学者数据建设与学术大数据数据分析
            <span class="about"></span>
          </h2>
          <h1
            style="visibility: visible; animation-delay: 0.5s;  animation-name: fadeInUp;"
          >从事学术数据挖掘分析，采用计量和大数据分析相结合的知识计算方法，深入挖掘学术数据发现学者成果关联，提供学者数据服务。</h1>
          <h1>
            项目组联系陆老师:邮箱：
            <span @click="copy">gqlu@zju.edu.cn</span>
          </h1>
        </div>
      </div>
    </aside>
    <div class="mobile-Us-main">
      <section>
        <div class="mobile-Us-main-body">
          <div class="mobile-Us-main-tab">
            <ul>
              <li>
                <a :class="active===1?'active':''" @click="active = 1">研发团队</a>
              </li>
              <li>
                <a :class="active===2?'active':''" @click="active = 2">顾问团队</a>
              </li>
            </ul>
          </div>
          <div class="mobile-Us-main-block"></div>
          <div v-if="active === 1" class="mobile-Us-main-experts">
            <div
              class="mobile-Us-main-list"
              v-for="(item,index) in experts"
              :key="index"
              @click="detail(item.url)"
            >
              <el-avatar :size="150" :src="item.src"></el-avatar>
              <p>{{item.name}}</p>
            </div>
          </div>

          <div v-if="active === 2" class="mobile-Us-main-experts">
            <div
              class="mobile-Us-main-list"
              v-for="(item,index) in consultants"
              :key="index"
              @click="detail(item.url)"
            >
              <el-avatar :size="150" :src="item.src"></el-avatar>
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Us",
  data() {
    return {
      active: 1,
      consultants: [
        {
          url: "http://expert.ckcest.cn/#/Mobile/Detail?kId=1723658522",
          src: "https://ciraa.zju.edu.cn/images/placeholder-profile-pyh.png",
          name: "潘云鹤",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授、博士生导师，浙江省“151”人才工程第三层次培养人员，浙江大学求是青年学者，微软学者，教育部-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "http://expert.ckcest.cn/#/Mobile/Detail?kId=1723712767",
          src: "https://ciraa.zju.edu.cn/images/placeholder-profile-zyt.png",
          name: "庄越挺",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授、博士生导师，浙江省“151”人才工程第三层次培养人员，浙江大学求是青年学者，微软学者，教育部-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "",
          src: "http://www.quant-chi.com/images/t7.jpg",
          name: "鲁伟明",
          position: "产品总监",
          field: "智能产品专家",
          intro:
            "博士、讲师。数字图书馆教育部工程研究中心、中国工程院-中国工程科技数据和知识技术研究中心青年骨干教师，2015年1月至2016年1月在英国帝国理工学院数据科学实验室(Data Science Institute)做访问学者。获得2007年浙江省科技进步奖一等奖（排名10），在IEEE Transactions on Multimedia, IEEE Transactions on Circuits and Systems for Video Technology, Neurocomputing, Information Processing and Management, Journal of Grid Computing及ACMM等重要学术期刊和学术会议发表论文40余篇，获授权发明专利7项，正在申请发明专利10余项，软件著作权11项。-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "http://expert.ckcest.cn/#/Mobile/Detail?kId=1723657675",
          src: "http://www.quant-chi.com/images/t8.jpg",
          name: "陈岭",
          position: "平台总监",
          field: "数据海专家",
          intro:
            "浙江大学计算机学院软件所副教授，博士生导师，现任浙江大学计算机学院普适计算实验室主任、浙大计算机学院鸿程商业智能技术研究中心副主任、鸿程智慧城市大型软件研究院副院长，入选浙江省“新世纪151人才工程”第三层次培养人员、浙江省青年科学家培养计划、浙江大学求是青年学者、浙江大学优秀青年教师资助计划。近年来负责国家级课题3项，省级课题3项，主参加国家级及省级课题7项，参加英国EPSRC项目Equator以及欧盟FP6项目IPerG。以第一和通信作者在TITS、DKE、Information Sciences等期刊和会议上发表学术论文60余篇。担任NCM、DMAMH等会议主席，ACCV、CASA等会议技术程序委员会委员，系统仿真学报、TOVRJ等期刊编委，中国计算机学会普适计算专委会委员，中国图象图形学学会虚拟现实专业委员会秘书，期刊TKDE、TPDS、TSMCA、CR以及会议ACM CHI、IEEE VR等的审稿工作，亦为系统仿真学报优秀审稿人。-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "",
          src: "http://www.quant-chi.com/images/t9.jpg",
          name: "汤斯亮",
          position: "",
          field: "知识图谱专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授，入选钱江人才计划，主要研究领域为概率主题建模、跨媒体内容整合、知识谱图构建与应用等。2005 年获得浙江大学计算机工学学士学位，2012 年获得爱尔兰国立大学（梅努斯）博士学位。表录用论文20 多篇，其中10余篇论文被IJCAI、AAAI（国际人工智能大会）、SIGMM（多媒体领域顶级会议）、SIGIR（信息检索领域顶级会议）、IEEEVIS（可视化年会）等顶级会议录用或发表申请发明专利12 项。-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        }
      ],
      experts: [
        {
          url: "http://expert.ckcest.cn/#/Mobile/Detail?kId=1723658917",
          src: "https://ciraa.zju.edu.cn/images/placeholder-profile-hc.png",
          name: "黄晨",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "根据数据搜索表明黄晨（专家）可见的最早中文论文发表是1999年在大学图书馆学报（期刊）上的Internet上图书馆的信息发布与共享一文，最早英文论文发表是1998年在INDIAN JOURNAL OF CHEMISTRY SECTION B-ORGANIC CHEMISTRY INCLUDING MEDICINAL CHEMISTRY（期刊）上的A simplified and practical method for methylation analysis of polysaccharides一文。截至2016年在大学图书馆学报、情报杂志、图书馆杂志、Chinese Journal of Lung Cancer、Applied Mechanics and Materials、Nature Genetics等6种期刊上共发文499篇，其研究领域主要集中在图书馆、情报与文献学、计算机科学技术、临床医学等方向。"
        },
        {
          url: "http://expert.ckcest.cn/#/Mobile/Detail?kId=1723735494",
          src: "/static/img/Us/lx.JPG",
          name: "刘翔",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授、博士生导师，浙江省“151”人才工程第三层次培养人员，浙江大学求是青年学者，微软学者，教育部-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "",
          src: "/static/img/Us/sls.jpg",
          name: "施干卫",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授、博士生导师，浙江省“151”人才工程第三层次培养人员，浙江大学求是青年学者，微软学者，教育部-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "",
          src: "/static/img/Us/fls.jpg",
          name: "方志坚",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授、博士生导师，浙江省“151”人才工程第三层次培养人员，浙江大学求是青年学者，微软学者，教育部-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "",
          src: "/static/img/Us/hls.jpg",
          name: "黄志强",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授、博士生导师，浙江省“151”人才工程第三层次培养人员，浙江大学求是青年学者，微软学者，教育部-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "",
          src: "http://expert.ckcest.cn/autoload/images/avatar.png",
          name: "王毓铭",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授、博士生导师，浙江省“151”人才工程第三层次培养人员，浙江大学求是青年学者，微软学者，教育部-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        },
        {
          url: "",
          src: "http://expert.ckcest.cn/autoload/images/avatar.png",
          name: "陆国强",
          position: "副总裁",
          field: "跨媒体技术专家",
          intro:
            "浙江大学计算机学院人工智能研究所副教授、博士生导师，浙江省“151”人才工程第三层次培养人员，浙江大学求是青年学者，微软学者，教育部-微软视觉感知重点实验室（浙江大学）青年骨干教师，兼任新加坡国立大学传感器增强社交媒体中心（SeSaMe Center）PI、浙江省疾控中心公共卫生研究院PI。获得浙江省自然科学奖一等奖（排名第5），在国内外期刊及学术会议上发表学术论文50余篇，与他人合作出版英文专著1部，获得国家发明专利授权29项，软件著作权19项。"
        }
      ]
    };
  },
  methods: {
    detail(url) {
      if (url) {
        window.location.href = url;
      }
    },
    copy() {
      var _input = document.createElement("input"); // 直接构建input
      _input.value = "gqlu@zju.edu.cn"; // 设置内容
      document.body.appendChild(_input); // 添加临时实例
      _input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(_input); // 删除临时实例
            this.$message.closeAll();
      this.$message({
        message: '复制成功',
        offset: 200
      });
    }
  }
};
</script>

<style lang="scss">
.mobile-Us {
  margin-top: 20px;
  .mobile-Us-header {
    background-color: #2e2e2e;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center left;
    height: 36em;
    z-index: 5;
    font-size: 0.85em;
    color: #ffffff;
    .mobile-Us-tit {
      display: flex;
      height: 36em;
      margin-right: auto;
      margin-left: auto;
      padding-left: 15px;
      padding-right: 15px;
      align-items: center;
      .mobile-Us-tit-intro {
        text-align: center;
        h2 {
          margin: 0 0 20px 0;
          padding: 0;
          font-family: inherit;
          font-weight: 500;
          letter-spacing: 4px;
          font-size: 24px;
          text-transform: uppercase;
          line-height: 60px;
          text-align: left;
          position: relative;
          color: #fff;
          border-bottom: 1px solid #fff;
          span {
            position: absolute;
            bottom: 3px;
            display: block;
            background: rgba(255, 255, 255, 0.4);
            height: 1px;
            left: 0%;
            margin-left: 0px;
          }
        }
        h1 {
          margin: 0 0 20px 0;
          padding: 0;
          font-family: inherit;
          font-weight: 500;
          font-size: 14px;
          font-weight: normal;
          line-height: 24px;
          text-transform: uppercase;
          letter-spacing: 2px;
          text-align: left;
        }
      }
    }
  }
  .mobile-Us-main {
    padding-top: 50px;
    z-index: 102;
    position: relative;
    background: #ffffff;
    .mobile-Us-main-body {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      min-height: 500px;
      margin-right: auto;
      margin-left: auto;
      padding-left: 15px;
      padding-right: 15px;
      .mobile-Us-main-tab {
        margin-top: -95px;
        position: relative;
        ul {
          line-height: 26px;
          list-style: none;
          margin-bottom: 10px;
          li {
            float: left;
            display: inline-block;
            a {
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              padding-left: 15px;
              padding-right: 15px;
              min-width: 160px;
              height: 45px;
              line-height: 45px;
              font-size: 16px;
              margin-right: 5px;
              background: #93a199;
              color: #fff;
              display: inline-block;
              text-align: center;
            }
            .active {
              background: #fff;
              color: #2e2e2e;
            }
            a:hover {
              background: #fff;
              color: #2e2e2e;
            }
          }
        }
      }
      .mobile-Us-main-block {
        height: 50px;
      }
      .mobile-Us-main-experts {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;

        .mobile-Us-main-list {
          display: flex;
          border-bottom: 1px solid #f1f1f1;
          padding-bottom: 30px;
          margin-bottom: 30px;
          font-size: 16px;
          line-height: 1.5;
          font-family: "Microsoft Yahei", arial, sans-serif;
          font-weight: 300;
          color: #2e2e2e;
          flex-direction: column;
          align-items: center;
          img {
            display: block;
            height: 100%;
            width: 100%;
            vertical-align: middle;
            cursor: pointer;
          }
          p {
            margin-top: 20px;
          }
          h2 {
            font-size: 22px;
            line-height: 38px;
            font-family: inherit;
            font-weight: 500;
            margin: 0 0 20px 0;
            .team_title {
              font-size: 14px;
              padding-left: 5px;
              font-style: normal;
            }
          }
        }
        @media screen and (max-width: 576px) {
          .mobile-Us-main-list {
            width: 48%;
          }
        }
        @media screen and (min-width: 576px) {
          .mobile-Us-main-list {
            width: 24%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mobile/Us.vue